import { StyledTitle } from '@shared/components/StyledComponents';

import { Box, Divider } from '@mui/material';
import { LiveWebsocketGrid } from '@shared/components/LiveWebsocketGrid';
import { LiveWebsocket } from '@protos/v2/serverinfo';
import { useAdminApi } from '@hooks/useAdminApi';
import { useAsync } from 'react-use';
import { useState } from 'react';
import { User } from '@protos/v2/otcQuote';

export const UserFilteredWebsockets = ({ user }: { user: User }) => {
  const { apiClient } = useAdminApi();
  const [liveWebsockets, setLiveWebsockets] = useState<LiveWebsocket[]>([]);
  useAsync(async () => {
    const fetchedLiveWebsockets = await apiClient?.getLiveWebsockets({ user_id: user.id });
    setLiveWebsockets(fetchedLiveWebsockets || []);
  }, [apiClient, user.id]);

  if (liveWebsockets.length === 0) {
    return null;
  }

  return (
    <Box mt={2}>
      <Divider />
      <Box display="flex" flexDirection="row" mt={2} pb="3px">
        <StyledTitle sx={{ flex: 1 }}>Websockets</StyledTitle>
      </Box>
      <LiveWebsocketGrid data={liveWebsockets} height="150px" />
    </Box>
  );
};
